export interface IMimeType {
  key: string;
  text: string;
  locked?: boolean;
}

const applicationAppleMpegURL = {
  key: 'application/vnd.apple.mpegURL',
  text: 'application/vnd.apple.mpegURL',
};
const applicationJavascript = { key: 'application/javascript', text: 'application/javascript' };
const applicationXMpegURL = { key: 'application/x-mpegURL', text: 'application/x-mpegURL' };
const video3gpp = { key: 'video/3gpp', text: 'video/3gpp' };
const videoMp4 = { key: 'video/mp4', text: 'video/mp4', locked: true };
const videoWebm = { key: 'video/webm', text: 'video/webm' };
const videoH264 = { key: 'video/H264', text: 'video/H264' };
const applicationDashXML = { key: 'application/dash+xml', text: 'application/dash+xml' };
const imageJpeg = { key: 'image/jpeg', text: 'image/jpeg' };
const imageJpg = { key: 'image/jpg', text: 'image/jpg' };
const imagePng = { key: 'image/png', text: 'image/png' };
const imageTiff = { key: 'image/tiff', text: 'image/tiff' };

const ctvMimeTypes: IMimeType[] = [videoMp4, videoH264, imageJpeg, imageJpg, imagePng, imageTiff];

const appMimeTypes: IMimeType[] = [videoMp4, videoH264, imageJpeg, imageJpg, imagePng, imageTiff];

const nativeVastMimeTypes: IMimeType[] = [
  videoMp4,
  videoH264,
  imageJpeg,
  imageJpg,
  imagePng,
  imageTiff,
];

const webMimeTypes: IMimeType[] = [
  applicationAppleMpegURL,
  applicationXMpegURL,
  video3gpp,
  videoMp4,
  videoWebm,
  videoH264,
  applicationDashXML,
  imageJpeg,
  imageJpg,
  imagePng,
  imageTiff,
];

const webVPAIDMimeTypes: IMimeType[] = [
  applicationAppleMpegURL,
  applicationJavascript,
  applicationXMpegURL,
  video3gpp,
  videoMp4,
  videoWebm,
  videoH264,
  applicationDashXML,
  imageJpeg,
  imageJpg,
  imagePng,
  imageTiff,
];

export const mimeTypes: { [key: string]: IMimeType[] } = {
  CTV: ctvMimeTypes,
  App: appMimeTypes,
  NativeVast: nativeVastMimeTypes,
  Web: webMimeTypes,
  WebVPAID: webVPAIDMimeTypes,
};
